import { defineField, defineType } from "sanity";

export const accountPage = defineType({
  name: "accountPage",
  title: "Account Page",
  type: "document",
  groups: [
    { name: "content", title: "Content", default: true },
    { name: "seo", title: "SEO" }
  ],
  fields: [
    defineField({
      name: "heroImage",
      title: "Hero image",
      type: "image",
      description: "Hero image at the top of the My Account page.",
      options: { hotspot: true },
      fields: [
        defineField({
          name: "alt",
          title: "Alt text",
          type: "string",
          description: "Describe the image for screen readers."
        })
      ],
      group: "content"
    }),
    defineField({
      name: "heroHeading",
      title: "Hero heading",
      type: "string",
      description: "Heading overlaid on the hero image (e.g. 'Your Account').",
      group: "content"
    }),
    defineField({
      name: "metaTitle",
      title: "Meta title",
      type: "string",
      description: "Page title for search engines.",
      group: "seo"
    }),
    defineField({
      name: "metaDescription",
      title: "Meta description",
      type: "text",
      rows: 3,
      description: "Short description for search engines.",
      group: "seo"
    }),
    defineField({
      name: "ogImage",
      title: "Sharing image",
      type: "image",
      description: "Image shown when this page is shared on social media.",
      options: { hotspot: true },
      fields: [
        defineField({
          name: "alt",
          title: "Alt text",
          type: "string",
          description: "Describe the image for screen readers."
        })
      ],
      group: "seo"
    })
  ],
  preview: {
    prepare: () => ({
      title: "Account Page"
    })
  }
});
